<template>
  <tr v-if="item">
    <td  :class="imageWidthClass + tdClass">
      <div v-if="rowHeading" class="caption">{{ rowHeading }}</div>
      <Player v-if="isPlaying"
        :reason="itemReason"
        :poster="image"
        autoplay
        :master="master"
      ></Player>
      <image-icon v-else
        :image="image"
        :row-type="rowType"
        @play-it="selectedImage"
        play-it="play-it"
        :avatar="!isFilm"
        :class="imageWidthClass"
      ></image-icon>
    </td>

    <td :class="'text-xs-left' + tdClass">
      <span>
        <v-icon v-if="isPlaying"
          color="accent"
          @click.stop="stopPlaying"
        >stop</v-icon>
        <span @click.stop="selectedStory">
          <span
            v-if="heading"
            class="font-weight-bold"
            >{{ heading }}
          </span>
          <v-icon small :color="detailsIconColor">
            {{ detailsIcon }}
          </v-icon>
        </span>
        <span v-if="awards">
          <award-blob
            v-for="(award,index) in awards"
              :key="index"
              :award="award"
          ></award-blob>
        </span>
      </span>
      <div v-if="url"><a :href="url" target=_blank>website</a></div>
      <span  @click.stop="selectedStory" v-if="story">
        <div :class="storyHeightClass" v-for="(sto,index) in story" :key=index>
          <Story :story="sto"></Story>
        </div>
      </span>
      <div>
        <Matches 
          :match-reasons="matchReasons" 
          class="text-xs-left hidden-md-and-up" 
          :compressed="compressed" 
          :row-type="rowType"
        ></Matches>
      </div>
    </td>

    <td :class="'text-xs-left hidden-sm-and-down fid-wide-reasons' + tdClass">
      <Matches 
        :match-reasons="matchReasons" 
        :compressed="compressed" 
        :row-type="rowType"
      ></Matches>
    </td>

  </tr>
</template>
<script>
import Story from '@/components/Story'
import Awardblob from '@/components/Awardblob'
import Matches from '@/components/Matches'
import Imageicon from '@/components/Imageicon'
import { SearchUtils } from '@/js'
import Player from '@/components/Player'
import { mergeControls } from '@/js/apollo'
import { settings, getIcon, getIconColor } from '@/js/store'
export default {
  components: {
    Matches,
    Player,
    Story,
    'image-icon': Imageicon,
    'award-blob': Awardblob
  },
  props: {
    rowHeading: String,
    compressed: Boolean,
    item: Object,
    playing: String,
    rowType: String,
    allPrizes: Array
  },
  methods: {
    stopPlaying () {
      mergeControls({
        playing: ''
      })
    },
    selectedImage () {
      if (this.isFilm) {
        mergeControls({
          playing: this.item.itemType + this.item.itemID
        })
      } else {
        this.stopPlaying()
        SearchUtils.routeChange({ router: this.$router, reason: this.patchReason })
      }
    },
    selectedStory () {
      this.stopPlaying()
      SearchUtils.routeChange({ router: this.$router, reason: this.patchReason })
    }
  },
  computed: {
    detailsIcon () {
      return getIcon('details')
    },
    detailsIconColor () {
      return getIconColor('details')
    },
    // this is because we want to masquerade a reason as a different type to pass off to the router which is showing a different type
    // this will copy the same behavior as when clicked from a reason chip
    patchReason () {
      return { ...this.itemReason, matchType: this.item.itemType, matchID: this.item.itemID, match: this.item.itemName }
    },

    // put a leading space in front of these classes so they can be combined
    storyHeightClass () {
      return this.bigEnough ? ' caption' : ' caption fid-story-height-sm'
    },
    imageWidthClass () {
      return !this.isFilm ? ' fid-avatar-width' : (this.bigEnough ? ' fid-player-width' : ' fid-player-width-sm')
    },
    tdClass () {
      return this.bigEnough ? '' : ' fid-td-sm'
    },
    bigEnough () {
      return this.$vuetify.breakpoint.mdAndUp
    },
    isFilm () {
      return this.item.itemType === 'film' || this.item.type === 'vimeofilm'
    },
    isPlaying () {
      return this.playing === this.item.itemType + this.item.itemID
    },
    matchReasons () {
      return this.item.MatchReasons
    },
    master () {
      return this.itemReason && 
        this.itemReason && 
        this.itemReason.Film && 
        this.itemReason.Film.FilmMasters && 
        this.itemReason.Film.FilmMasters[0]
    },
    itemReason () {
      return this.item && this.item.itemReason
    },
    image () {
      return SearchUtils.getImageFromReason({
        reason: this.itemReason,
        rowType: this.rowType,
        minHeight: settings.dimensions.posterFrameHeight
      })
    },
    heading () {
      return SearchUtils.getTextFromReason({ reason: this.itemReason, rowType: this.rowType })
    },
    awards () {
      return SearchUtils.getAwardsFromReason({ reason: this.itemReason, rowType: this.rowType })
    },
    story () {
      return SearchUtils.getStoryFromReason({ reason: this.itemReason, rowType: this.rowType, allPrizes: this.allPrizes })
    },
    url () {
      return SearchUtils.getUrlFromReason({ reason: this.itemReason, rowType: this.rowType })
    }
  },
  name: 'Itemrow'
}
</script>
